import listCacheClear from "./component-library442.mjs";
import listCacheDelete from "./component-library443.mjs";
import listCacheGet from "./component-library444.mjs";
import listCacheHas from "./component-library445.mjs";
import listCacheSet from "./component-library446.mjs";
function ListCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
export {
  ListCache as default
};
